import React, {useEffect, useRef, useState} from "react";
import { useTranslation } from "react-i18next";
import Input from "common/src/components/widget/Input";
import useUpdateOnlyEffect from "common/src/hooks/effect/useUpdateOnlyEffect";
import {isEqual} from "lodash";

const ColumnsDescriptionControl = ({ aggregations, selectedColumns, columnDescriptionFormField, disabled }) => {
    const { t } = useTranslation();
    const [columnDescription, setColumnDescription] = useState(columnDescriptionFormField?.value || {});
    const [externalColumnDescription, setExternalColumnDescription] = useState(columnDescriptionFormField?.value || {});

    const previousColumnDescription = useRef(columnDescriptionFormField?.value || {});

    const [requiredKeys, setRequiredKeys] = useState([]);
    useEffect(() => {
        if (!isEqual(columnDescriptionFormField.value, previousColumnDescription.current)) {
            setColumnDescription(columnDescriptionFormField.value || {});
            setExternalColumnDescription(columnDescriptionFormField.value || {});
            previousColumnDescription.current = columnDescriptionFormField.value || {};
        }
    }, [columnDescriptionFormField.value]);

    useEffect(() => {
        if (!isEqual(columnDescription, externalColumnDescription)) {
            columnDescriptionFormField.setValue(columnDescription, undefined, true);

        } else {
            previousColumnDescription.current = columnDescription;
        }
    }, [columnDescription, externalColumnDescription]);

    useEffect(() => {
        const keys = [
            ...(selectedColumns?.value?.map(col => col.label) || []),
            ...(aggregations?.value?.map(agg => agg.label) || [])
        ];
        setRequiredKeys(keys);
    }, [  aggregations.value, selectedColumns.value]);

    useUpdateOnlyEffect(() => {
        setColumnDescription((current) => {
            const updatedColumnDescription = { ...current, ...columnDescriptionFormField?.value };
            // Remove keys that are no longer required
            Object.keys(updatedColumnDescription).forEach((key) => {
                if (!requiredKeys.includes(key)) {
                    delete updatedColumnDescription[key];
                }
            });

            // Add descriptions for new required keys from aggregations
            aggregations?.value?.forEach((aggregation) => {
                const key = aggregation.label;
                if (updatedColumnDescription[key] === undefined) {
                    const description = `Represents table aggregation: "${aggregation.operation}(${aggregation.columnName}) as ${aggregation.label}"`;
                    updatedColumnDescription[key] = description;
                }
            });

            // Add descriptions for new required keys from selected columns
            selectedColumns?.value?.forEach((column) => {
                const key = column.label;
                if (updatedColumnDescription[key] === undefined) {
                    const description = `Represents table column: "${column.name} as ${column.label}"`;
                    updatedColumnDescription[key] = description;
                }
            });

            return updatedColumnDescription;
        });
    }, [requiredKeys, aggregations?.value, selectedColumns?.value]);

    const handleDescriptionChange = (label, value) => {
        columnDescriptionFormField.setValue({
            ...columnDescriptionFormField.value,
            [label]: value,
        }, undefined, true);
    };
    return (
        <div className="columns-description-control">
            <div className="columns-description-control__content">
                <div className="columns-description-control__content__list">
                    {columnDescription && Object.keys(columnDescription).map((label, index) => (
                        <div key={label + index} className="columns-description-control__content__list__item">
                            <div className="columns-description-control__content__list__item__description">
                                <Input
                                    label={label}
                                    value={columnDescription[label]}
                                    onChange={(e) => handleDescriptionChange(label, e)}
                                    disabled={disabled}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ColumnsDescriptionControl;
